const { parseInt } = global;
const { floor, round, ceil } = Math;

export { ceil, floor, parseInt, round };
